import { Injectable } from '@angular/core';
import { Form } from '../models/form-builder/form.model';

/*
 * This singleton service (well all services are singletons) is a start to 'remembering' a user's
 * preferences, activities, for the present only 'remembering' the last form used (when creating a
 * new form instances).
*/

@Injectable({
    providedIn: 'root'
})
export class MostRecentFormSelectedService {
    // Properties.
    private form: Form = null;

    // Constructor.
    constructor() { }

    // Methods.
    public set Form(site: Form) {
        this.form = site;
    }

    public get Form(): Form {
        return this.form;
    }
}
